import React, { type Dispatch, type SetStateAction } from 'react';
import { useTranslationContext } from '@/context/translation';
import { useTranslationWithLocale } from '@/hooks/useTranslationWithLocale';
import { AmplitudeService } from '@/services';
import { type TabItem } from '@/data/aiToolLandings';
import { AMPLITUDE_EVENTS } from '@/constants/amplitudeEvents';
import styles from './Search.module.scss';

interface SearchTabProps {
	setSearchActive: Dispatch<SetStateAction<boolean>>;
	tabData: TabItem;
}

export const SearchTab = ({ tabData, setSearchActive }: SearchTabProps) => {
	const { locale, translations } = useTranslationContext();
	const { t, isLoading } = useTranslationWithLocale(
		'tools',
		locale,
		translations?.['tools'] as Record<string, unknown> | undefined,
	);

	// Don't render title until translations are ready to avoid showing keys
	const title = isLoading ? null : t(tabData.title);

	return (
		<button
			key={tabData.id}
			type='button'
			className={styles['search-tab']}
			onClick={() => {
				AmplitudeService.logEvent(AMPLITUDE_EVENTS.ALL_TOOLS_SEARCH_OPENED);
				setSearchActive(true);
			}}
		>
			<span className={styles['search-tab__emoji']}>{tabData.emoji}</span>
			<span
				className={`${styles['search-tab__title']} ${
					isLoading ? styles['search-tab__title_loading'] : ''
				}`}
			>
				{title || '\u00A0'}
			</span>
		</button>
	);
};
